const RESOURCE_NAME = "entities/walletCharges";

export default {};
